import PropTypes from "prop-types";
import React from "react";
import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";

const ConfirmationModal = ({
  show,
  setShowModal,
  deleteFunction,
  deleteArguments,
  title,
  message,
}) => {
  return (
    <Modal
      show={show}
      onHide={() => setShowModal(false)}
      dialogClassName="modal-50w"
      aria-labelledby="example-custom-modal-styling-title"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-custom-modal-styling-title">
          {title || "¿Está seguro de que desea eliminar el elemento?"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {message && (
          <div className="text-center mb-3">
            <p>{message}</p>
          </div>
        )}
        <div className="d-flex justify-content-center">
          <Button
            className="mx-2"
            variant="success"
            onClick={() => {
              setShowModal(false);
              deleteFunction(...deleteArguments);
            }}
          >
            Aceptar
          </Button>{" "}
          <Button variant="danger" onClick={() => setShowModal(false)}>
            Cancelar
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

ConfirmationModal.propTypes = {
  show: PropTypes.bool,
  setShowModal: PropTypes.func,
  deleteFunction: PropTypes.func,
  deleteArguments: PropTypes.array,
  title: PropTypes.string,
  message: PropTypes.string,
};

export default ConfirmationModal;
